<template>
    <section class="view fix-space__button" v-if="hasPermissions(['Assignment-Daily-Complete Read'])">
        <div class="row mb-0">
            <div class="col-12 duties pt-0">
               <BreadcrumbVueRouter :breadcrumb="breadcrumb"/>

                <h1 class="view__title title--1" v-html="`Complete Daily Assignment ( ${title_page} )`"/>

                <div class="view__description">
                    <p class="view__description__text">
                        Check off rooms as you complete them. Use the Add Discharge and Add Unassigned Work buttons to enter additional work.
                    </p>
                </div>
                <div class="row">
                    <div class="col-md-12 assignment-complete">
                        <Datepicker
                            class="ml-1"
                            v-model="previous_date" 
                            name="previous_date_picker"
                            :wrapper-class="'wrapperClass'"
                            :input-class="'datepicker__input-class'"
                            :format="datepickerFormat"
                            :disabled="disabledDates"
                            :calendar-button="true"
                            :calendar-button-icon="'fa fa-calendar'"
                            placeholder="Select a date"
                            ref="programaticOpen"
                        />
                        <button
                            class="modal__buttons__item"
                            @click="previous_date = ''"
                        >
                            <i class="fa fa-undo" />
                        </button>

                    </div>

                </div>

                <div class="row detail__content__notes" style="margin-top:20px; max-height:250px;" v-if="assignment_notes.length">
                    <div class="col-lg-3" v-for="(note, i) in assignment_notes" :key="i">
                        <div class="row mb-0 no-gutters h-100">
                            <div class="col-12 card cardList hoverable">
                                <div class="card-content h-100">
                                    <div class="card-title">
                                        <div class="row mb-0 no-gutters">
                                            <div class="col-10">
                                                <a class="textTitleCard" v-html="`${note.title} <span style='font-size: 13px; font-weight: normal;'> / ${note.created_at}</span>`"/>
                                            </div>
                                            <div class="col-2 text-right" v-if="!has_role('Employee')">
                                                <a @click="!has_role('Employee') ? note_modal_deletion(i) : null">
                                                    <i class="material-icons prefix" >
                                                        <img class="iconCard" src="/assets/img/trash.png" alt="date" style="right: 0rem; top: -6px; width: 24px; height: auto;" />
                                                    </i>
                                                </a>
                                            </div>
                                        </div>
                                        <div class="row mb-0 no-gutters">
                                            <div class="col-12">
                                                <p class="mt-3 card-content__text" v-html="note.body_text" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="alert alert-primary mt-3" role="alert" v-if="rooms_assigned_for_today">
                    <i class="fa fa-info-circle mr-3" style="font-size: 15px;"/><b>{{rooms_assigned_for_today}}</b> room{{ rooms_assigned_for_today > 1 ? 's' : '' }} have been moved to this daily assignment for today only
                </div>
                <div class="alert alert-primary mb-2" role="alert" v-for="(item, i) in notifications" :key="i">
                    <span class="w-100">
                        <p class="mb-0"> <span class="mr-2" style="color: #6b6b6b;">{{item.time}}</span><strong> {{ item.name }}</strong> has made changes to the following rooms: 
                            <b>**</b> 
                            <span v-for="(work_page, j) in item.rooms" :key="j"> ({{work_page.room}} - {{work_page.task}})  <b v-if="j < (item.rooms.length - 1)">-</b></span> 
                        </p>
                    </span>
                    <span class="position-absolute mb-0" style="top: 0; right: 5px;">
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="deleteNotification(i)">
                            <img width="15px" src="/assets/img/svg/close.svg" alt="delete">
                        </button>
                    </span>
                </div>
                <div class="col-md-12" v-if="rooms.length" style="margin-top:20px;">
                    <div class="table-responsive table-fix-head" :style="`max-height: 35rem`">
                        <table class="table">
                            <thead style="background-color: #f1f1f1; ">
                                <tr>
                                    <th :style="display_rooms.length && display_rooms[0]['only_for_today'] ? 'border-bottom: 0' : ''" class="header-item-manual" scope="col" v-for="(item, i) in room_table_headers" :key="i" v-html="item.name"/>
                                    <th :style="display_rooms.length && display_rooms[0]['only_for_today'] ? 'border-bottom: 0' : ''" class="header-item-manual" scope="col" v-html="`Complete`"/>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(item, i) in display_rooms" :key="i" class="assignment-row" :style="(item.only_for_today) ? style_for_today_rooms : ''">
                                    <td v-html="item.room"/>
                                    <td v-html="item.task"/>
                                    <td v-html="item.step_codes.join(' - ')"/>
                                    <td>
                                        <span>
                                            <input 
                                                :disabled="true"
                                                :id="`input${i}`"
                                                type="number"
                                                :min="1" :max="1000"
                                                class="form-control"
                                                :value="i+1"
                                                :placeholder="''"
                                                style="color:black;"
                                            />
                                        </span>
                                    </td>
                                    <td style="width: 40%">
                                        <div class="d-flex flex-wrap">
                                            <span class="custom-control custom-checkbox  d-flex flex-column  mb-2" v-for="page in item.daily_assignment_work_pages" :key="page.id">
                                                <div class="mb-1">
                                                    <input :id="`completed${page.id}`" type="checkbox" class="custom-control-input" v-model="page.checked" @change="setIsDirty(item)"/>
                                                    <label :for="`completed${page.id}`" class="custom-control-label checkbox-no-absolute"/>
                                                </div>
                                                <span class="small-text" v-html="page.name"/>
                                                <span class="small-text gray-text">{{ (page.is_new) ? moment.unix(page.created_at).format('hh:mm A') : moment(page.created_at).format('hh:mm A')}}</span>
                                            </span>
                                            <span class="custom-control custom-checkbox">
                                                <input :id="`completed${i}`" type="checkbox" :checked="false" @change="checkWork(item.daily_assignment_work_pages, item)"/>
                                                <label :for="`completed${i}`" class="custom-control-label ml-4"/>
                                            </span>
                                        </div>    
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div class="row mb-0">
                    <div class="col-md-auto flex-xl-grow-1">
                        <div class="modal__buttons text-center text-md-left text-lg-center" style="margin-top:15px;">
                            <button
                                class="modal__buttons__item"
                                v-html="`Save progress`"
                                style="margin-top:20px; float:right;"
                                @click="save_progress()"
                            />
                        </div>
                        <div class="modal__buttons text-center text-md-left text-lg-center" style="margin-top:15px;">
                            <button
                                class="modal__buttons__item"
                                v-html="`Add unassigned work`"
                                style="margin-top:20px; float:right;"
                                @click="showUnassignedWorkModal()"
                            />
                        </div>
                        <div class="modal__buttons text-center text-md-left text-lg-center" style="margin-top:15px;">
                            <button
                                class="modal__buttons__item"
                                v-html="`Add Discharges`"
                                style="margin-top:20px; float:right;"
                                @click="showBedsModal()"
                            />
                        </div>
                    </div>

                    <div class="report__table" v-if="resume_step_codes.length">
                        <div class="report__table__footer">
                            Step Descriptions
                        </div>
                        <div class="report__table__content">
                            <ul class="report__table__footer__list">
                                <li class="report__table__footer__list__item" v-for="(item, i) in resume_step_codes" :key="i" v-html="item ? `${item.code} - ${item.name}` : ''"/>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        
        <WaitingModal/>

        <ConfirmationModal
            :message="'Daily Assignment completion submitted successfully.'"
            :second_message="'Would you like to return to the main Daily Assignments screen?'"
            @ConfirmEmition="back_to_assignment()"
        />

        <FormModalBeds 
            :parent_rest_api="self_rest_api" 
            :rest_api="rest_api_bed" 
            :title="'Add Discharges'"
            :parent_id="parent_id"
            :from_daily_assignment="true"
            :daily_assignment="single_object"
            :breadcrumb="breadcrumb_for_modals"
            :current_associate="current_associate"
            :previous_date="previous_date"
            ref="form_modal_beds"
        />

        <FormModalUnassignedWork
            :title="'Additional Unassigned Work'"
            :daily_assignment="single_object"
            :parent_id="parent_id"
            :breadcrumb_modal="breadcrumb_for_modals"
            :previous_date="previous_date"
            ref="form_unassigned_work"
        />

        <DeletionModal 
            :single_object="single_note" 
            :global_index="index_note" 
            @objectDeletion="note_trash($event)"
        />

        <SaveProgressModal
            :message="'Confirmation save Progress.'"
            :second_message="'Would you like to save progress?'"
            @ConfirmEmition="confirmation_save_progress($event)"
        />

    </section>
    <div v-else>
        <UnauthorizedComponent :breadcrumb="breadcrumb"/>
    </div>
</template>

<script>

import BreadcrumbVueRouter    from  '@/components/BreadcrumbComponent/BreadcrumbVueRouter.vue'
import FormResources          from  './form_resources'
import Resources              from  './resources'
import WaitingModal           from  '@/components/WaitingModal'
import ConfirmationModal      from  '@/components/ConfirmationModal.vue'
import DeletionModal          from '@/components/DeletionModal'
import SaveProgressModal      from './SaveProgressModal'
import Datepicker              from 'vuejs-datepicker';
import UnauthorizedComponent from   '@/components/UnauthorizedComponent'
import FormModalBeds  from  './FormModalBeds'
import FormModalUnassignedWork from './FormModalUnassignedWork'
import { Notyf }              from  'notyf'
import eventBus               from '@/plugins/eventBus'
import 'vuetify/dist/vuetify.min.css'
import 'notyf/notyf.min.css' // for React and Vue
const notyf = new Notyf({
    duration: 8000,
})
import moment from 'moment'
import { changeAssignmentForAssignmentComplete, emitRoomsCleanedForDashboard, getSocket, socket_connected } from '../../../plugins/socket'

window.onunload = function () {
    eventBus.$emit("redirectto")
}

export default {
    name: 'DailyAssignmentComplete',

    components: {
        BreadcrumbVueRouter,
        WaitingModal,
        ConfirmationModal,
        DeletionModal,
        SaveProgressModal,
        UnauthorizedComponent,
        FormModalBeds,
        FormModalUnassignedWork,
        Datepicker
    },
    
    data(){
        return{
            notyf,
            parent_id:            this.$route.params.id,
            user:                 this.get_user(),
            rest_api:             `daily_assignments/${this.$route.params.id}`,
            lite_rest_api:        `daily_assignments`,
            rest_api_note:        `assignment_notyfs`,
            rest_api_bed:          `discharge_beds`,
            // self_rest_api:        !this.has_role('Employee') ? 'daily-assignment-complete' : 'daily_assignments_employee',
            self_rest_api:        'daily_assignments_employee',
            form_format:          FormResources.form_format,
            breadcrumb:           Resources.breadcrumb,
            breadcrumb_employee:  Resources.breadcrumb_employee,
            title_page:           '',
            single_object:        {},
            check_completed_task: false,

            array_options: {
                show_minutes: Resources.standard_options,
                associate_id: []
            },

            rooms:                  [],
            single_body_object:     {},
            body_index:             null,
            room_table_headers:     Resources.room_complete_table_headers,
            select_all:             false,
            show_scheduled_minutes: true,
            associate_id:           '',
            current_date:           '',
            project_work_page_id:   '',
            display_current_date:   this.currentDateToString(),
            report_name:            '',
            today:                  new Date(),
            assignment_notes:       [],
            single_note:            {},
            index_note:             null,
            resume_step_codes:      [],
            next_page:              '',
            current_associate:      null,
            breadcrumb_for_modals: Resources.breadcrumb_modal_beds,
            notifications: [],
            previous_date: '',
            first_time_loading: true,
            disabledDates: {
                from: new Date()
            },
            fake_id: 1,
            moment,
            rooms_assigned_for_today: 0,
            style_for_today_rooms: 'border: solid; border-color: rgb(25 39 173);',
            socket: socket_connected.value
        }
    },

    watch:
    {
        async 'previous_date'(date)
        {
            this.retrieveData(this.convertObjectDateToStringDate(date))
        },

        socket_connected(val)
        {
            console.log('socket connected');
            console.log(val);
        }

    },

    methods: {

        checkWork(work_pages, room)
        {
            const obj = {
                id: `local-${this.fake_id++}`,
                checked: true,
                is_new: true,
                associate_id: this.current_associate.id,
                name: `${this.current_associate.last_name}, ${this.current_associate.first_name}`,
                created_at: this.getCurrentDateTime(this.previous_date),
            }

            room.completed = false

            this.setIsDirty(room)
            
            work_pages.push(obj)
        },

        setIsDirty(room)
        {
            room.is_dirty = true
        },


        cleanWorkPages(rooms, from_real_time = false)
        {
            rooms.forEach(item => 
            {
                let found_index = this.rooms.findIndex(room => room.id == item.id)

                if(found_index > -1)
                {
                    if(from_real_time)
                    {
                        let local_work_pages = this.rooms[found_index].daily_assignment_work_pages
                       
                        local_work_pages.forEach(local_page => {

                            if(local_page.is_new)
                            {
                                this.setIsDirty(item)
                                item.daily_assignment_work_pages.push(local_page)
                            }

                            let found_index = item.daily_assignment_work_pages.findIndex(work_page => work_page.id == local_page.id)

                            if(found_index > -1)
                            {
                                this.setIsDirty(item)
                                item.daily_assignment_work_pages[found_index]['checked']  = local_page.checked
                            }
                            
                        });
                    }
                    
                    this.rooms.splice(found_index, 1, item)
                }
            })
        },

        deleteNotification(index)
        {
            this.notifications.splice(index, 1)
        },

        note_modal_deletion(index)
        {
            this.index_note = index
            this.single_note = {...this.assignment_notes[index]}
            window.$('#static-deletion').modal('show')
        },

        async note_trash(object_destroyed)
        {
            this.loader(true)

            let json_request = {
                notyf_detach: true,
                daily_assignment_id: this.parent_id,
                assignment_notyf_id: object_destroyed.id,
            }

            const response = await this.delete(`${this.rest_api_note}/${JSON.stringify(json_request)}`)

            if(response.status)
            {
                this.index_note = null
                this.single_note = {}
                this.assignment_notes.splice(object_destroyed.index, 1)
                notyf.success('Deleted success!')
                window.$('#static-deletion').modal('hide')
                this.loader()
            } 
            else
            {
                this.error_handling(response)
                this.loader()
            }
        },

        async getNotes()
        {
            let json_request = {
                note_request: true,
                daily_assignment_id: this.parent_id,
            }

            let route = `${this.lite_rest_api}/${JSON.stringify(json_request)}`

            let response = await this.get(route)

            if(response.status)
            {
                this.assignment_notes = response.data.notes
            }
            else
            {
                this.error_handling(response)
            }
        },

        async daily_assignment_complete()
        {
            let rooms_selected = this.rooms

            this.loader(true)
            const form_data = {
                rooms: rooms_selected,
                daily_assignment_id: this.parent_id,
            }

            let url = `${this.self_rest_api}`

            if(this.previous_date)
            {
                url += `?date=${this.convertObjectDateToStringDate(this.previous_date)}`
            }

            let response = await this.post(`${url}`, form_data)
            this.loader()

            if(response.status)
            {
                emitRoomsCleanedForDashboard(this.get_user().facility_id)
                this.cleanWorkPages(response.data.refresh_data)

                this.notyf.success('Completed success!')
            }
            else
            {
                this.error_handling(response)

            }
        },

        async getSpecificRooms(room_ids)
        {
            const form_data = 
            {
                room_ids,
                daily_assignment_id: this.single_object.id
            }

            let response = await this.post(`${this.self_rest_api}/socket/specific_rooms`, form_data)

            if(response.status)
            {
                this.cleanWorkPages(response.data.rooms, true)
            }

        },

        back_to_assignment()
        {
            window.location.href = !this.has_role('Employee') ? `/assignment-daily-assignments/${this.parent_id}` : '/assignment-daily-assignments'
        },

        async fill_data(data)
        {   
            await this.getNotes()

            let data_rooms = data.rooms_assigned

            data_rooms.map((item) => {
                item['new'] = true
                item['completed'] = false
            })

            this.rooms = data_rooms
            this.single_object = data.daily_assignment
            this.associate_id = this.single_object.associate_id
            this.title_page = `${this.single_object.number_assigment} - ${this.single_object.description}`
            this.current_associate = data.current_associate
            this.rooms_assigned_for_today = data.rooms_assigned_for_today


            if(data.resume_step_codes.length)
            {
                let resume_step_codes = data.resume_step_codes.sort(function(a, b)
                {
                    return parseInt(a.code) - parseInt(b.code)
                })

                this.resume_step_codes = resume_step_codes.map(item => item.step_code)
            }

            if(this.first_time_loading)
            {
                this.breadcrumb[2].arrow = "<span class='slash'>/</span>"

                const new_link_1 =  {
                    name: this.single_object.description,
                    href: `/assignment-daily-assignments/${this.parent_id}`,
                    arrow: "<span class='slash'>/</span>",
                }
                    
                const new_link_2 = {
                    name: `Complete Daily Assignment ( ${this.title_page} )`,
                    href: `/assignment-daily-assignment-complete/${this.parent_id}`,
                    arrow: "",
                }

                const new_link_modal = {
                name: `Complete Daily Assignment ( ${this.title_page} )`,
                href: `/assignment-daily-assignment-complete/${this.parent_id}`,
                arrow: "",
                }

                this.breadcrumb_for_modals.push(new_link_modal)

                this.breadcrumb.push(new_link_1, new_link_2)
            }
            

            this.array_options.associate_id = data.associates.filter(item => item.id === this.associate_id)

            this.first_time_loading = false


        },

        selectAll()
        {
            if(this.rooms.length)
            {
                this.rooms.map(item => {
                    item.checked = this.select_all
                })
            }
        },

        datepickerFormat(date) 
        {
            return moment(date).format('MM/DD/YYYY');
        },

        async save_progress()
        {
            if(this.hasPermissions(['Assignment-Daily-Complete Write']))
            {
               this.daily_assignment_complete()
            }
            else
            {
                this.notyf.error('you do not have permission to perform these operations')
            }
        },

        async confirmation_save_progress(flag)
        {
            if(flag)
            {
                await this.save_progress()
            }

            setTimeout(() => {
                window.location.href = this.next_page
            }, 500)
        },

        showUnassignedWorkModal()
        {
            window.$('#unassigned-work-modal').modal('show')
            this.$refs.form_unassigned_work.initialFunction()
        },

        showBedsModal()
        {
            window.$('#static-update').modal('show')
            this.$refs.form_modal_beds.initialSetup()

        },

        async retrieveData(date = '')
        {
            let url = `${this.self_rest_api}/${this.$route.params.id}`

            if(date)
            {
                url += `?date=${date}`
            }

            await this.api_request(url)
        }

    },

    computed:
    {
        display_rooms()
        {
            return this.rooms
        },
        
        selected()
        {
            let bool = this.rooms.filter(item => item.completed && item.new)
            return Boolean(bool.length)
        }
    },

    async mounted()
    {
        if(this.hasPermissions(["Assignment-Daily-Complete Read"]))
        {
            const today = new Date()
            today.setHours(23, 59, 59, 999);
            this.disabledDates.from = new Date(today.setDate(today.getDate() - 1))
            this.retrieveData()

            if(this.parent_id)
            {
                changeAssignmentForAssignmentComplete(this.parent_id)
            }
        }

        eventBus.$on("redirectto", this.before_leave);
    },

    async created()
    {
        eventBus.$on('assignment_complete', () => 
        {
            const channelName = `${this.parent_id}-${this.getTodayDate()}`

            console.log(channelName);

            const socket = getSocket();

            socket.on(channelName, (data) => 
            {
                if(data?.rooms.length)
                {
                    if(this.current_associate?.id)
                    {
                        if(data.changed_by.id != this.current_associate?.id)
                        {
                            this.notifications.unshift({name: `${data.changed_by.last_name}, ${data.changed_by.first_name}`, rooms: data.rooms, time: this.getCurrentDatetime().format('H:mm')})
                        }
                    }
                    else if(data.changed_by.id != this.user.id )
                    {
                        this.notifications.unshift({name: `${data.changed_by.last_name}, ${data.changed_by.first_name}`, rooms: data.rooms, time: this.getCurrentDatetime().format('H:mm')})
                    }

                    this.getSpecificRooms(data.rooms.map( item => item.id))
                }
            })
        })

        eventBus.$on('redirectTo', (href) => {
            if(this.hasPermissions(['Assignment-Daily-Complete Write']))
            {
                this.next_page = href
                this.$forceUpdate()
                window.$('#save-progess-modal').modal('show')
            }
        })
    
    },
  
    beforeRouteLeave (to) {
        if(this.hasPermissions(['Assignment-Daily-Complete Write']))
        {
            this.next_page = to.path
            this.$forceUpdate()
            window.$('#save-progess-modal').modal('show')
        }
        else
        {
            window.location.href =  to.path
        }
    },

}
</script>
<style scoped>

</style>